import { FETCH_LLM } from "routes/ApiEndpoints";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { AJ_WEB_CONNECTOR } from "Constants";
import {
  t,
  translate,
} from "components/CentralDataMangement/translation/Translation";
import LinkTo from "components/common/atoms/LinkTo";
import NoRecords from "components/common/atoms/NoRecords";
import SpinnerWrapper from "components/common/atoms/SpinnerWrapper";
import Title from "components/common/atoms/Title";
import { ApiCall } from "components/common/services/ApiServices";
import AccessControl from "components/common/services/RolesAndPermissions/AccessControl";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import EditIcon from "static/images/EditIcon";
import CustomNotify from "components/common/atoms/CustomNotify";

interface LlmModelProps {
  name: string;
  id: number;
}

const ManageLlmProviders: React.FC = () => {
  const [loading, setLoading] = useState(false);

  const [llmProviders, setLlmProviders] = useState<LlmModelProps[]>([]);

  useEffect(() => {
    setLoading(true);
    fetchDetails();
  }, []);

  const fetchDetails = async () => {
    setLoading(true);
    const data = {
      type: 'provider'
    }
    const url = FETCH_LLM;
    const response = await ApiCall.service(
      url,
      "POST",
      data,
      false,
      AJ_WEB_CONNECTOR
    );

    if (response && response?.status == 200) {
      setLlmProviders(response?.data);
    } else {
      CustomNotify({
        type: "error",
        message: t("Some error occured"),
      });
    }
    setLoading(false);
  };

  return (
    <AccessControl
      requiredPermissions={[
        {
          permission: "Content creation",
          read: true,
        },
      ]}
      renderNoAccess={true}
    >
      <>
        <div
          className={`main-container`}
        >
          <Title title={t("LLM providers")} />
          <div className="form-height-dashboard">
            <div className="position-relative tableMainWrapper">
              <div className="row">
                <div className="ManageCreateBtn">
                  <AccessControl
                    requiredPermissions={[
                      {
                        permission: "Content creation",
                        create: true,
                      },
                    ]}
                  >
                    <LinkTo
                      pagelink="/llm-provider"
                      title={t("Add provider")}
                      icon={faPlus}
                    // className="marginRightPoint5"
                    />
                  </AccessControl>
                </div>
              </div>

              <div className="table-responsive tableSection">

                <div className="manageLlmrovideWrapper scrollBarDesign" style={{ paddingTop: "0.2vw" }}>
                  <table className="table table-hover manageCompanies">
                    <thead>
                      <tr className="TableHeader">
                        <th >{t("Name")}</th>
                        <th>
                          <AccessControl
                            requiredPermissions={[
                              {
                                permission: "Content creation",
                                update: true,
                                delete: true,
                              },
                            ]}
                            actions={true}
                            strict={false}
                          >
                            {t("Action")}
                          </AccessControl>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <SpinnerWrapper headerLength={9} />
                      ) : (
                        <>
                          {llmProviders && llmProviders.length > 0 ? (
                            llmProviders.map((llmProvider, index) => {
                              return (
                                <tr
                                  key={llmProvider.id}
                                  className="border-bottom align-middle"
                                >
                                  <td> {llmProvider.name}</td>
                                  <td className="table-action-icons">
                                    <AccessControl
                                      requiredPermissions={[
                                        {
                                          permission: "Content creation",
                                          delete: true,
                                          update: true,
                                        },
                                      ]}
                                      actions={true}
                                      strict={false}
                                    >
                                      <AccessControl
                                        requiredPermissions={[
                                          {
                                            permission: "Content creation",
                                            update: true,
                                          },
                                        ]}
                                      >
                                        <Link
                                          to={`/llm-provider/${llmProvider.id}`}
                                          title={t("Edit")}
                                          className="me-2"
                                        >
                                          <EditIcon />
                                        </Link>
                                      </AccessControl>
                                    </AccessControl>
                                  </td>
                                </tr>
                              );
                            })
                          ) : (
                            <NoRecords headerLength={4} />
                          )}
                        </>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

        </div>
        <div className="row backPadding">
          <div className="col-md-6 align-self-center">
            <Link to="/manage-content-creation" className="back-btn text-decoration-underline">
              {t("Back")}
            </Link>
          </div>
        </div>
      </>
    </AccessControl >
  );
};

export default translate(ManageLlmProviders);
